import { ColorInput as MantineColorInput, ColorInputProps } from "@mantine/core"
import { forwardRef } from "react"

import { Label } from "../../../atoms/Label/Label"
import { EqualWidthGrid } from "../../../layout/EqualWidthGrid/EqualWidthGrid"
import { Loader } from "../../../molecules/Loader/Loader"

type Props = {
  isLoading?: boolean
  inlineLabel?: boolean
} & ColorInputProps

export const ColorInput = forwardRef<HTMLInputElement, Props>(
  ({ isLoading = false, inlineLabel = false, label, value, ...props }, ref) => {
    const input = (
      <MantineColorInput
        ref={ref}
        label={inlineLabel ? undefined : label}
        value={value ?? undefined}
        rightSection={isLoading ? <Loader size="xs" /> : undefined}
        {...props}
      />
    )

    return inlineLabel ? (
      <EqualWidthGrid>
        <Label label={label} />
        {input}
      </EqualWidthGrid>
    ) : (
      input
    )
  }
)

ColorInput.displayName = "ColorInput"
